/**
 * Historia zapytań przeglądarki bazy — lokalnie w przeglądarce, per tenant.
 * Wygoda dla wdrożeniowca (powrót do niedawnego SELECT-a), NIE audyt: audyt pisze serwer.
 */

export interface QueryHistoryEntry {
  sql: string;
  at: string;
  ok: boolean;
  rows: number;
  ms: number;
}

const MAX = 50;
const key = (tenantId: string) => `saas_db_browser_history:${tenantId}`;

export function readHistory(tenantId: string): QueryHistoryEntry[] {
  try {
    const raw = localStorage.getItem(key(tenantId));
    const parsed: unknown = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? (parsed as QueryHistoryEntry[]) : [];
  } catch {
    return [];
  }
}

export function addHistory(tenantId: string, entry: QueryHistoryEntry): QueryHistoryEntry[] {
  const next = [entry, ...readHistory(tenantId).filter((e) => e.sql !== entry.sql)].slice(0, MAX);
  try {
    localStorage.setItem(key(tenantId), JSON.stringify(next));
  } catch {
    // Pełny/zablokowany storage — historia działa wtedy tylko w tej sesji.
  }
  return next;
}
